import useMediaQueries from '@stone/hooks/useMediaQueries';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const PriceDisplay = (props) => {
    var _a;
    const { t } = useTranslation();
    const { isMobile } = useMediaQueries();
    const printMinRangePrice = () => {
        return (React.createElement(React.Fragment, null,
            props.minFullPrice && props.minFullPrice !== props.min && React.createElement("del", { className: "product-price-list" }, props.minFullPrice),
            props.min));
    };
    if (props.type === 'range') {
        return (React.createElement("span", { className: classNames('product-price', {
                inline: props.inline,
            }) },
            window.language != 'ja' && t('label.from') + ' ',
            printMinRangePrice(),
            window.language == 'ja' && ' ' + t('label.from')));
    }
    const promo = (_a = props.promotions) === null || _a === void 0 ? void 0 : _a[0];
    const hasDiscountPrice = props.list && !props.isExchangePrice && (props === null || props === void 0 ? void 0 : props.list) !== (props === null || props === void 0 ? void 0 : props.sales);
    const a11yRender = () => {
        return (React.createElement("span", { className: "visually-hidden" }, props.list && !props.isExchangePrice ? (t('product.price.discounted.a11y', {
            originalprice: props.list,
            currentprice: props.sales,
            currency: props.currency,
        })) : (React.createElement(React.Fragment, null,
            props.isExchangePrice && t('order.exchangecredit'),
            " ",
            props.sales,
            " ",
            props.currency ? ` ${props.currency}` : ''))));
    };
    return (React.createElement(React.Fragment, null,
        a11yRender(),
        React.createElement("span", { className: classNames('product-price', {
                inline: props.inline,
                discount: hasDiscountPrice,
                'justify-between': props.isPlp && isMobile && hasDiscountPrice,
            }), "aria-hidden": true },
            React.createElement("span", { className: classNames('product-price-wrap', {
                    'd-column': props.isPlp && isMobile && hasDiscountPrice,
                }) },
                hasDiscountPrice && React.createElement("del", { className: "product-price-list" }, props.list),
                React.createElement("span", { className: "product-price-sale" },
                    props.sales,
                    props.currency ? ` ${props.currency}` : '')),
            (promo === null || promo === void 0 ? void 0 : promo.calloutMsg) && React.createElement("span", { className: "product-price-msg" }, promo.calloutMsg))));
};
PriceDisplay.defaultProps = {
    inline: false,
};
export default PriceDisplay;
